export const VIRTUAL_GROUP_ESTIMATED_HEIGHT_PX = 200;

export const MINIMUM_OLDER_MESSAGE_GROUPS_TO_VIRTUALIZE = 5;

// Keep anchoring briefly after mount while virtual measurements and async
// message content resolve, then stop so user-driven scrolling is respected.
export const INITIAL_ANCHOR_SETTLING_WINDOW_MS = 1000;
